module.exports = __webpack_public_path__ + "static/img/5.60cca98.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/sp/5.png
// module id = hG7f
// module chunks = 0